import React from 'react'
import './TermsandConditions.css'

const TermsandCondition = () => {
  return (
    <div className="terms-container">
      <h1>Terms of Use</h1>

      <p>
        Access to and use of <strong>viyavarfashions.com</strong>, our physical
        outlets (if any), and the products and services available through the
        website are subject to the following terms, conditions, and notices
        (“Terms of Use”). By using our website (
        <a href="https://viyavarfashions.com" target="_blank" rel="noreferrer">
          https://viyavarfashions.com
        </a>
        ), you agree to be bound by these Terms of Use along with our Privacy
        Policy.
      </p>

      <p>
        We reserve the right to review, modify, suspend, or withdraw the Services
        without notice. We shall not be liable if the Website is unavailable at
        any time.
      </p>

      <h2>1. Introduction</h2>
      <p>
        The domain name <strong>https://viyavarfashions.com</strong> is operated
        by <strong>Viyavar Fashions</strong>, doing business as Viyavar, a business
        registered in India.
      </p>
      <address>
        173A, Anna Nagar, Industrial Estate,
        <br />
        Karur, Tamil Nadu – 639004, India
      </address>

      <h2>2. Services</h2>
      <p>
        Viyavar Fashions is an online fashion and apparel retailer offering
        clothing and related products. By placing an order, you authorize us to
        process, ship, and deliver your purchase and receive payment.
      </p>

      <h2>3. Your Account</h2>
      <p>
        You are responsible for maintaining the confidentiality of your account
        credentials and all activities conducted under your account. We reserve
        the right to suspend or terminate accounts at our discretion.
      </p>

      <h2>4. Privacy</h2>
      <p>
        Your use of the Website is governed by our Privacy Policy. The Services
        are hosted in India, and by using them, you consent to data processing in
        India.
      </p>

      <h2>5. Product Information & Pricing</h2>
      <p>
        Product images are for illustrative purposes only. Prices are subject to
        change without notice. In case of pricing errors, orders may be canceled
        and refunded.
      </p>

      <h2>6. Payment (Including Razorpay Policies)</h2>
      <p>
        Payments are processed securely through <strong>Razorpay</strong>. We
        accept UPI, Credit/Debit Cards, Net Banking, and other supported methods.
      </p>
      <p>
        Viyavar Fashions is not responsible for payment failures caused by banks
        or payment gateways. Refunds will follow Razorpay’s policies.
      </p>

      <h2>7. Delivery</h2>
      <p>
        Delivery timelines are estimates. Orders are shipped through third-party
        logistics partners, and delays may occur due to external factors.
      </p>

      <h2>8. Returns & Refunds</h2>
      <p>
        Returns and refunds are handled by delivery partners based on product
        condition and verification. Refund timelines may vary.
      </p>

      <h2>9. Intellectual Property Rights</h2>
      <p>
        All website content, including logos, text, images, and designs, is the
        intellectual property of Viyavar Fashions and is protected by law.
      </p>

      <h2>10. Third-Party Websites</h2>
      <p>
        We are not responsible for third-party websites linked from our
        platform.
      </p>

      <h2>11. Indemnification</h2>
      <p>
        You agree to indemnify Viyavar Fashions against claims arising from your
        misuse of the Website or violation of these Terms.
      </p>

      <h2>12. Violation & Termination</h2>
      <p>
        We reserve the right to terminate access if these Terms are violated.
      </p>

      <h2>13. Governing Law</h2>
      <p>
        These Terms are governed by the laws of India. Courts in India shall have
        exclusive jurisdiction.
      </p>

      <h2>14. Wallet, Offers & Cancellations</h2>
      <ul>
        <li>Non-transferable</li>
        <li>Cannot be exchanged for cash</li>
        <li>Subject to specific conditions</li>
      </ul>

      <h2>Contact Us</h2>
      <p>
        <strong>Viyavar Fashions</strong>
        <br />
        173A, Anna Nagar, Industrial Estate
        <br />
        Karur, Tamil Nadu – 639004, India
      </p>
      <p>
         Phone: <a href="tel:6383532399">6383532399</a>
        <br />
        Email:{" "}
        <a href="mailto:viyavarfashion@gmail.com">
          viyavarfashion@gmail.com
        </a>
      </p>
    </div>
  );
};


export default TermsandCondition